import React from 'react';
import { Button } from 'react-bootstrap';
import { updatePTextById } from "../../Utils/helpers";
import { getToken } from "../../Utils/Common";
import { createAnnotation } from "../../API/annotatorApi";
import $ from "jquery";
import { Box } from 'react-feather';

function RenderAnswerComponent({ position, categories, adviceList, lv_id, annotationData, setAnnotationData }) {
    const paragraphId = position.row_id;

    const handleNewAnnotation = async (lvID, ID, rowID, annotation, positionText) => {
        let serverResponse = await createAnnotation(lvID, ID, rowID, annotation, positionText);
        if (serverResponse.status === 200) {
            console.log("Successfully created new annotation");
            return true;
        } else {
            return false;
        }
    };

    const updateUIState = (rowID, selectedAnnotationID, annotation, positionText) => {
        let state = annotationData;
        let updatedDocument = updatePTextById(state.lv_document, rowID, positionText);
        let exists = state.annotations.some((obj) => obj.unique_id === selectedAnnotationID);
        if (exists) {
            let newState = state.annotations.filter((obj) => obj.unique_id !== selectedAnnotationID);
            newState.push(annotation);
            let update = { annotations: newState, lv_document: updatedDocument };
            setAnnotationData(update);
        } else {
            state.annotations.push(annotation);
            let update = { annotations: state.annotations, lv_document: updatedDocument };
            setAnnotationData(update);
        }
        console.log(annotationData);
    };

    const sendQuestion = async () => {
        try {
            const questions = await fetchQuestions(categories);
            const questionStrings = questions.map(q => q.question);

            const response = await fetch(`${process.env.REACT_APP_BASE_URI}/QApipeline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ q: questionStrings, c: position.long_text, lv_id: lv_id, rowId: paragraphId })
            });
            const responseData = await response.json();
            renderAnswers(responseData, questions);
        } catch (error) {
            console.error('Error fetching response:', error);
        }
    };

    const fetchQuestions = async (categoriesToFetch) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URI}annotator/fetch_prompts_by_category`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ "token": getToken(), category: categoriesToFetch })
            });
            const data = await response.json();
            return data.response; // Assuming this returns an array of { advice, question, category }
        } catch (error) {
            console.error('Error fetching questions:', error);
        }
    };

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    const renameKeyInPlaceNested = (obj, oldKey, newKey) => {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (key === oldKey) {
                    obj[newKey] = obj[oldKey];
                    delete obj[oldKey];
                } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    renameKeyInPlaceNested(obj[key], oldKey, newKey);
                }
            }
        }
        return obj;
    };

    const removeExistingMarks = (text) => {
        return text.replace(/<\/?mark[^>]*>/gi, '');
    };

    const restoreMarks = (text, markers) => {
        markers.forEach(marker => {
            const placeholder = `%%%${marker.unique_id}%%%`;
            text = text.replace(placeholder, marker.mark);
        });
        return text;
    };

    const renderAnswers = async (answers, questions) => {
        const paragraphElement = document.getElementById(paragraphId);

        if (paragraphElement) {
            let paragraphText = paragraphElement.innerHTML;

            // Save existing marks and their positions
            const existingMarks = [];
            paragraphText = paragraphText.replace(/<mark(.*?)>(.*?)<\/mark>/gi, (match) => {
                const uniqueId = generateUUID();
                existingMarks.push({ mark: match, unique_id: uniqueId });
                return `%%%${uniqueId}%%%`;
            });

            // Remove existing marks
            paragraphText = removeExistingMarks(paragraphText);

            let annotations = [];
            const classIdentifier = 'p' + paragraphId.split('=')[1] + "-mark"; // Prepend 'p' to make it a valid class name

            answers.forEach(answer => {
                const correspondingQuestion = questions.find(q => q.question === answer.question);
                if (correspondingQuestion) {
                    const answerText = escapeRegExp(answer.answer);
                    const regex = new RegExp(`(${answerText})`, 'gi');
                    const uniqueId = generateUUID();
                    const placeholder = `%%%${uniqueId}%%%`;
                    paragraphText = paragraphText.replace(regex, placeholder);

                    let foundObject = { ...adviceList.find(obj => obj.uidid === correspondingQuestion.advice) }; // Create a copy to avoid mutating the original object
                    foundObject['menge'] = position.menge;
                    foundObject['rowId'] = position.row_id;
                    foundObject['ord'] = position.ref;
                    foundObject['Annotation'] = answer.answer;
                    foundObject['short_text'] = position.hinweis;
                    foundObject['unique_id'] = uniqueId;
                    foundObject['adviceID'] = foundObject.uidid;
                    foundObject['value'] = '';
                    foundObject['lv_id'] = lv_id;

                    renameKeyInPlaceNested(foundObject, 'formel', "formula");
                    renameKeyInPlaceNested(foundObject, 'category', "type");
                    renameKeyInPlaceNested(foundObject, 'anspruch', "law");

                    updateUIState(position.row_id, uniqueId, foundObject, paragraphText);
                    annotations.push(foundObject);
                }
            });

            // Replace placeholders with mark elements
            annotations.forEach(annotation => {
                const regex = new RegExp(`%%%${annotation.unique_id}%%%`, 'g');
                paragraphText = paragraphText.replace(regex, `<mark id="${annotation.unique_id}" class="${classIdentifier}">${annotation.Annotation}</mark>`);
            });

            // Restore existing marks
            paragraphText = restoreMarks(paragraphText, existingMarks);

            paragraphElement.innerHTML = paragraphText;
            await handleNewAnnotation(lv_id, '', paragraphId, annotations, paragraphText);

            // Reattach event listeners after rendering
            const marks = paragraphElement.querySelectorAll(`.${classIdentifier}`);
            marks.forEach(mark => {
                const annotationID = mark.id;
                const foundObject = annotations.find(annotation => annotation.unique_id === annotationID);
                if (foundObject) {
                    mark.addEventListener('click', () => {
                        $("mark").remove(".dashed-border-mark");
                        updateAnnotatorUI(annotationID, foundObject);
                        localStorage.setItem("annotationID", annotationID);
                        $('#'+ annotationID).addClass("dashed-border-mark");
                    });
                }
            });
        }
    };

    const updateAnnotatorUI = (annotationID, annotDataValue) => {
        console.log(`updateAnnotatorUI called with ID: ${annotationID}`);
        console.log('Annotation Data:', annotDataValue);

        $("#norm").val(clearHTML(annotDataValue.norm || ""));
        $("#advice").val(clearHTML(annotDataValue.advice || ""));
        $("#agl").val(clearHTML(annotDataValue.law || ""));
        $("#kommentor").val(clearHTML(annotDataValue.kommentor || ""));
        $("#category").val(clearHTML(annotDataValue.type || ""));
        $("#formel").val(clearHTML(annotDataValue.formula || "keine Formel"));
        $("#ursache").val(clearHTML(annotDataValue.Annotation || ""));
    };

    const clearHTML = (html) => {
        let div = document.createElement("div");
        div.innerHTML = html;
        return div.innerText || div.textContent || "";
    };

    return (
        <div>
            <Button  size="sm" variant="primary" className="handwai-btn-report" onClick={sendQuestion}>
               <Box />  Render
            </Button>
        </div>
    );
}

export default RenderAnswerComponent;